import { AppSelect } from '@ui/applications';
import { Popover } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { COPY_SPECIFIC, FULL_ROUTES } from '@sonar-software/sonar-ts-constants';
export const ApplicationExplorerMenuItem = () => {
    const navigate = useNavigate();
    return (React.createElement(Popover, { content: React.createElement(AppSelect, { includeDetected: true, onChange: (appId) => navigate(`${FULL_ROUTES.DATA_SECURITY}${appId ? `/${appId}` : ''}`) }), placement: 'bottom', title: COPY_SPECIFIC.SELECT_AN_APPLICATION, trigger: 'click' }, COPY_SPECIFIC.APPLICATION_EXPLORER));
};
